import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const zipAttachmentApi = createApi({
  reducerPath: 'zipAttachmentApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1/zip_attachments' }),
  endpoints: (builder) => ({
    createZipAttachment: builder.mutation({
      query: (body) => ({
        method: 'POST',
        body
      })
    })
  })
})

export const { useCreateZipAttachmentMutation } = zipAttachmentApi
export { zipAttachmentApi }